import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogGrade } from "../models/CatalogGrade";

export const getCatalogGrades = async (): Promise<CatalogGrade[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[FAB].[GetGrades]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogGrade[];
	}
	throw new Error(resp.message || "Error fetching catalog grades");
};

export const upsertCatalogGrade = async (grade: CatalogGrade) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "GradeId", value: grade.GradeId },
		{ name: "GradeName", value: grade.GradeName },
		{ name: "Enabled", value: grade.IsActive },
	];
	return await apiService.callV2("[FAB].[UpsertGrade]", parameters);
};

export const deleteCatalogGrade = async (gradeId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "GradeId", value: gradeId }];
	return await apiService.callV2("[FAB].[DeleteGrade]", parameters);
};
